  @import '../../global/style/all-tenants/custom-properties/components-properties/splide-sliders';

  :host {
    @include cms-components-host-defaults;
    grid-area: var(--cms-default-grid-area);
    width: 100%;
  }

  :host * {
    box-sizing: border-box;
  }

  .cms-material-tools-slider-inner {
    --cms-grid-padding: 1rem;
    @include cms-default-grid-container;
    background: var(--cms-semanticColors-transparency-strong-background);
    border: var(--cms-border-size-xs) solid var(--cms-theme-border-color);
    height: var(--cms-container-height);
    width: var(--cms-container-width);
    position: relative;
  }

  .cms-material-tools-slider-inner>* {
    --cms-default-grid-area: auto / auto / auto / span 12;
    grid-area: var(--cms-default-grid-area);
  }

  .article-name-wrapper {
    @include headline-font-150;
    font-size: var(--cms-adaptive-font-size-175);
    text-align: center;
    color: var(--cms-theme-text-color);
    margin: var(--cms-spacing-100) 0;
  }

  .category-cta {
    margin: var(--cms-spacing-100) 0;
    width: 100%;
  }

  .article-slider-list {
    cursor: pointer;
  }

  .article-image-wrapper {
    width: 80%;
    @include cms-margin-center;
  }

  .article-slider-cta {
    text-decoration: none;
    color: var(--cms-semanticColors-base-strong-text);
  }

  .badge-wrapper {
    position: absolute;
    top: calc(var(--cms-spacing-150) * -1);
  }

  .cms-material-tools-slider-badge {
    @include headline-font-150;
    font-size: var(--cms-font-size-150);
    padding: var(--cms-spacing-075);
    display: inline-block;
    background-size: 100% 100%;
  }

  .splide-inner {
    height: var(--cms-container-height);
  }

  .splide__slider {
    height: 100%;
    align-content: space-between;
  }

  .splide__track--draggable {
    @include splide-track-draggable;
  }

  .splide__sr {
    @include splide-sr;
  }

  .splide__container {
    @include splide-container;
  }

  .pagination {
    text-align: center;
    font-family: var(--cms-brandfont2);
    margin-top: var(--cms-spacing-075);
  }

  .pagination span {
    margin-right: var(--cms-spacing-050);
  }

  .splide__list {
    @include splide-list;
    grid-auto-columns: calc((100% - var(--cms-grid-gap)));
  }

  .splide.is-initialized:not(.is-active) .splide__list {
    @include splide-initialized-not-active;
  }

  .splide {
    @include splide-root;
    margin: auto;
    width: var(--cms-container-width);

  }

  .splide.is-initialized,
  .splide.is-rendered {
    @include splide-initialized-rendered;
  }

  .splide__slide {
    @include splide-slide;
  }

  .splide__slide img {
    vertical-align: bottom;
  }

  .splide__track {
    @include splide-track;
  }

  .splide-arrow {
    --cms-arrow-top: 50%;
    --cms-arrow-transform: translateY(-50%);
    @include splide-arrow;
  }

  .splide__arrow--prev {
    --cms-arrow-prev-left: 0px;
    --cms-arrow-next-right: inherit;
    @include splide-arrow-prev;
  }

  .splide__arrow--next {
    --cms-arrow-prev-left: inherit;
    --cms-arrow-next-right: 0px;
    @include splide-arrow-next;
  }

  @include media-width($breakpoint-sm) {
    :host {
      --cms-default-grid-area: auto / auto / auto / span 6;
    }

    .splide__arrows {
      display: block;
    }
  }